export default __webpack_public_path__ + "static/media/Hero.f68d28e1.png";